import React from 'react';
import { Card } from './ui/card';
import { Clock, Trash2, Users } from 'lucide-react';
import { format } from 'date-fns';

const TimeEntryCard = ({ entry, onDelete, onEdit }) => {
  const hours = Math.floor(entry.duration_minutes / 60);
  const minutes = entry.duration_minutes % 60;

  const getEntryTypeColor = (type) => {
    switch (type) {
      case 'meeting':
        return 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 border border-purple-200 dark:border-purple-800';
      case 'work':
        return 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800';
      case 'break':
        return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-800';
      default:
        return 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600';
    }
  };

  return (
    <Card 
      className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm shadow-md border-0 dark:border-gray-700 hover:shadow-lg hover:scale-[1.01] transition-all cursor-pointer" 
      data-testid={`time-entry-${entry.id}`}
      onClick={() => onEdit(entry)}
    >
      <div className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex items-start space-x-3 flex-1">
            {entry.project_color && (
              <div
                className="w-1 h-16 rounded-full flex-shrink-0"
                style={{ backgroundColor: entry.project_color }}
              />
            )}
            <div className="flex-1">
              {entry.project_name && (
                <p className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1 transition-colors" data-testid="entry-project">{entry.project_name}</p>
              )}
              <p className="text-gray-800 dark:text-gray-200 mb-2 transition-colors" data-testid="entry-notes">{entry.notes}</p>
              <div className="flex flex-wrap items-center gap-2">
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium transition-colors ${getEntryTypeColor(entry.entry_type)}`} data-testid="entry-type">
                  {entry.entry_type}
                </span>
                <span className="inline-flex items-center text-xs text-gray-600 dark:text-gray-400 transition-colors" data-testid="entry-duration">
                  <Clock className="w-3 h-3 mr-1" />
                  {hours > 0 && `${hours}h `}{minutes}m
                </span>
                {entry.attendees && entry.attendees.length > 0 && (
                  <span className="inline-flex items-center text-xs text-gray-600 dark:text-gray-400 transition-colors" data-testid="entry-attendees">
                    <Users className="w-3 h-3 mr-1" />
                    {entry.attendees.join(', ')}
                  </span>
                )}
              </div>
            </div>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(entry.id);
            }}
            className="text-gray-400 dark:text-gray-500 hover:text-red-500 dark:hover:text-red-400 transition-colors p-2"
            data-testid={`delete-entry-${entry.id}`}
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </Card>
  );
};

export default TimeEntryCard;
